var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOfferExclusive(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 33.032,
    height: 33.032,
    viewBox: "0 0 33.032 33.032",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_13381",
    "data-name": "Group 13381",
    transform: "translate(-3077 -10609)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_837",
    "data-name": "Ellipse 837",
    cx: 16.5,
    cy: 16.5,
    r: 16.5,
    transform: "translate(3077 10609.031)",
    fill: "#ed8b00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ellipse_837_-_Outline",
    "data-name": "Ellipse 837 - Outline",
    d: "M16.516,1.739A14.777,14.777,0,1,0,31.293,16.516,14.794,14.794,0,0,0,16.516,1.739m0-1.739A16.516,16.516,0,1,1,0,16.516,16.516,16.516,0,0,1,16.516,0Z",
    transform: "translate(3077 10609)",
    fill: "#ed8b00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5528",
    "data-name": "Path 5528",
    d: "M9.516.849",
    transform: "translate(3084 10609.6)",
    fill: "gray"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_11939",
    "data-name": "Group 11939",
    transform: "translate(3085.693 10617.692)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Ellipse_838",
    "data-name": "Ellipse 838",
    d: "M3.477,1.739A1.739,1.739,0,1,0,5.216,3.477,1.74,1.74,0,0,0,3.477,1.739M3.477,0A3.477,3.477,0,1,1,0,3.477,3.477,3.477,0,0,1,3.477,0Z",
    fill: "#fedbb7"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_11940",
    "data-name": "Group 11940",
    transform: "translate(3094.385 10626.385)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Ellipse_838-2",
    "data-name": "Ellipse 838",
    d: "M3.477,1.739A1.739,1.739,0,1,0,5.216,3.477,1.74,1.74,0,0,0,3.477,1.739M3.477,0A3.477,3.477,0,1,1,0,3.477,3.477,3.477,0,0,1,3.477,0Z",
    transform: "translate(0)",
    fill: "#fedbb7"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Line_119",
    "data-name": "Line 119",
    d: "M.368,16.885a.869.869,0,0,1-.722-1.352L10.077-.113a.869.869,0,1,1,1.447.964L1.093,16.5A.869.869,0,0,1,.368,16.885Z",
    transform: "translate(3087.931 10617.323)",
    fill: "#fedbb7"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOfferExclusive);
export default __webpack_public_path__ + "static/media/offer_exclusive.eeedab92139d19e070126d10c6bd7d8b.svg";
export { ForwardRef as ReactComponent };